import React from "react";
import { Box, Card, CardContent, Typography, Link } from "@mui/material";

interface ValidationError {
  field: string;
  reason: string;
  message: string;
}

interface DataDisplayProps {
  data: ValidationError[];
}

const DataDisplay: React.FC<DataDisplayProps> = ({ data }) => {
  return (
    <Box sx={{ padding: 4, maxWidth: "800px", margin: "0 auto" }}>
      {/* Errors */}
      {data.map((error, index) => (
        <Card
          key={index}
          sx={{
            backgroundColor: "#fff4f4", // Light pink for a soft error background
            border: "1px solid #ffb4b4", // Subtle red border for error emphasis
            borderRadius: "6px",
            marginBottom: 2,
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ padding: "12px 16px" }}>
            {/* Field */}
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, marginBottom: 0.5, color: "#b71c1c" }}
            >
              Field: <span style={{ color: "#880e4f" }}>{error.field}</span>
            </Typography>

            {/* Reason */}
            <Typography
              variant="body2"
              sx={{ marginBottom: 0.5, color: "#b71c1c" }}
            >
              <strong>Reason:</strong>{" "}
              <span style={{ color: "#d84315" }}>{error.reason}</span>
            </Typography>

            {/* Message */}
            <Typography
              variant="body2"
              sx={{ color: "#b71c1c" }}
            >
              <strong>Message:</strong>{" "}
              {error.message.includes("https://") ? (
                <Link
                  href={error.message.match(/https:\/\/[^\s]+/)?.[0]}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#1565c0", // Blue for the URL
                    textDecoration: "underline",
                  }}
                >
                  Refer URL
                </Link>
              ) : (
                <span style={{ color: "#d84315" }}>{error.message}</span>
              )}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default DataDisplay;